import { InputBar } from "./style";
import { iInputSearch } from "./types";

export const InputSearch = ({ children }: iInputSearch) => {
  return <InputBar>{children}</InputBar>;
};
